export default __webpack_public_path__ + "static/media/EMERGENCY PUSH BUTTON IN DRILLING MACHINE SIMULATOR.5e1d94b5.jpg";